export default __webpack_public_path__ + "static/media/ed_1.6bd57743.mp3";